"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bkdr_hash_1 = require("./bkdr-hash");
/**
 * Convert RGB Array to HEX
 *
 * @param {Array} RGBArray - [R, G, B]
 * @returns {String} 6 digits hex starting with #
 */
function RGB2HEX(RGBArray) {
    var hex = "#";
    RGBArray.forEach(function (value) {
        if (value < 16) {
            hex += 0;
        }
        hex += value.toString(16);
    });
    return hex;
}
exports.testForRGB2HEX = RGB2HEX;
var paramToColor = function (p, q) { return function (color) {
    if (color < 0) {
        color++;
    }
    if (color > 1) {
        color--;
    }
    if (color < 1 / 6) {
        color = p + (q - p) * 6 * color;
    }
    else if (color < 0.5) {
        color = q;
    }
    else if (color < 2 / 3) {
        color = p + (q - p) * 6 * (2 / 3 - color);
    }
    else {
        color = p;
    }
    return Math.round(color * 255);
}; };
/**
 * Convert HSL to RGB
 *
 * @see {@link https://en.wikipedia.org/wiki/HSL_and_HSV} for further information.
 * @param {Number} H Hue ∈ [0, 360)
 * @param {Number} S Saturation ∈ [0, 1]
 * @param {Number} L Lightness ∈ [0, 1]
 * @returns {Array} R, G, B ∈ [0, 255]
 */
function HSL2RGB(H, S, L) {
    var H360 = H / 360;
    var q = L < 0.5 ? L * (1 + S) : L + S - L * S;
    var p = 2 * L - q;
    var partial = paramToColor(p, q);
    return [partial(H360 + 1 / 3), partial(H360), partial(H360 - 1 / 3)];
}
exports.testFroHSL2RGB = HSL2RGB;
/**
 * Color Hash Class
 *
 * @class
 */
var ColorHash = /** @class */ (function () {
    function ColorHash(options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c;
        var LS = [
            (_a = options.lightness, (_a !== null && _a !== void 0 ? _a : [0.35, 0.5, 0.65])),
            (_b = options.saturation, (_b !== null && _b !== void 0 ? _b : [0.35, 0.5, 0.65]))
        ].map(function (param) {
            return Array.isArray(param) ? param.concat() : [param];
        });
        this.L = LS[0];
        this.S = LS[1];
        if (typeof options.hue === "number") {
            options.hue = { min: options.hue, max: options.hue };
        }
        if (typeof options.hue === "object" && !Array.isArray(options.hue)) {
            options.hue = [options.hue];
        }
        if (typeof options.hue === "undefined") {
            options.hue = [];
        }
        this.hueRanges = options.hue.map(function (range) {
            return {
                min: typeof range.min === "undefined" ? 0 : range.min,
                max: typeof range.max === "undefined" ? 360 : range.max
            };
        });
        this.hash = (_c = options.hash, (_c !== null && _c !== void 0 ? _c : bkdr_hash_1.BKDRHash));
    }
    ColorHash.prototype.getHue = function (hash) {
        if (this.hueRanges.length > 0) {
            var range = this.hueRanges[hash % this.hueRanges.length];
            var hueResolution = 727; // note that 727 is a prime
            return ((((hash / this.hueRanges.length) % hueResolution) *
                (range.max - range.min)) /
                hueResolution +
                range.min);
        }
        else {
            return hash % 359; // note that 359 is a prime
        }
    };
    /**
     * Returns the hash in [h, s, l].
     * Note that H ∈ [0, 360); S ∈ [0, 1]; L ∈ [0, 1];
     *
     * @param {String} str string to hash
     * @returns {Array} [h, s, l]
     */
    ColorHash.prototype.hsl = function (str) {
        var hash = this.hash(str);
        var H = this.getHue(hash);
        var sHash = Math.floor(hash / 360);
        var S = this.S[sHash % this.S.length];
        var lHash = Math.floor(sHash / this.S.length);
        var L = this.L[lHash % this.L.length];
        return [H, S, L];
    };
    /**
     * Returns the hash in [r, g, b].
     * Note that R, G, B ∈ [0, 255]
     *
     * @param {String} str string to hash
     * @returns {Array} [r, g, b]
     */
    ColorHash.prototype.rgb = function (str) {
        var hsl = this.hsl(str);
        return HSL2RGB.apply(void 0, hsl);
    };
    /**
     * Returns the hash in hex
     *
     * @param {String} str string to hash
     * @returns {String} hex with #
     */
    ColorHash.prototype.hex = function (str) {
        var rgb = this.rgb(str);
        return RGB2HEX(rgb);
    };
    return ColorHash;
}());
exports.default = ColorHash;
//# sourceMappingURL=color-hash.js.map